export const isNotNullOrUndefined = <T>(input: null | undefined | T): input is T =>
    input !== null && input !== undefined;

export const isNullOrUndefined = <T>(input: null | undefined | T): input is null | undefined =>
    input === null || input === undefined;

export const trim = (input: string): string => (input && input !== '' ? input.trim() : '');

export const getEnumKeysAsNumber = <T>(input: T): number[] =>
    Object.keys(input)
        .filter(item => !Number.isNaN(Number(item)))
        .map(item => Number(item));

export const formatPhone = (code, num: string) => {
  if (num && num.length === 10) {
    return code + num.slice(1);
  } else if (num && num.length === 9) {
    return code + num;
  } else {
    return '';
  }
};
